module.exports = __webpack_public_path__ + "img/x.671a596c.png";